export default __webpack_public_path__ + "static/media/approved_list.b4cada77.svg";